export default __webpack_public_path__ + "static/lead-sp-9727b7ac81f99fa3b9bc56052066fe92.svg";